<body class="user-admin">
  <app-table-header
    [headerText]="headerText"
    [hasRadioButton]="hasRadioButton"
    [radioHeader]="radioHeader"
    [firstOptionValue]="firstOptionValue"
    [firstOptionName]="firstOptionName"
    [secondOptionValue]="secondOptionValue"
    [secondOptionName]="secondOptionName"
    [radioModel]="radioModel"
    [filterDisabled]="!isFilterEnabled"
    [hasAddItem]="isAdminSearch && canAddUsers"
    [rightPadding]="10"
    (exportRadioButtonChange)="emitRadioButtonChange($event)"
    (clearFilterEvent)="clearAllFilters()"
    (exportExcelEvent)="exportExcel()"
    (addItemEvent)="addUser()"
  ></app-table-header>
  <div
    class="user-admin-table-container"
    [ngClass]="{ 'admin-search-screen': isAdminSearch }"
  >
    <table mat-table class="user-admin-table" [dataSource]="dataSource">
      <caption>
        User Admin
      </caption>
      <!-- User ID -->
      <ng-container matColumnDef="loginId">
        <th mat-header-cell *matHeaderCellDef id="user-id-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.USER_ID"
            [control]="userIdData.formControl"
            [maxLength]="10"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="user-id-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let admin"
          onkeypress="viewUser(admin)"
          (click)="viewUser(admin)"
        >
          <a class="selectable">
            {{ admin.loginId }}
          </a>
        </td>
      </ng-container>

      <!-- Employee ID -->
      <ng-container matColumnDef="employeeId">
        <th mat-header-cell *matHeaderCellDef id="employee-id-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.EMPLOYEE_ID"
            [control]="employeeIdData.formControl"
            [maxLength]="15"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="employee-id-headers"
          class="left-data-column"
          mat-cell
          *matCellDef="let admin"
          onkeypress="viewUser(admin)"
          (click)="viewUser(admin)"
        >
          <a class="selectable">
            {{ admin.employeeId }}
          </a>
        </td>
      </ng-container>

      <!-- Last name -->
      <ng-container matColumnDef="familyName">
        <th mat-header-cell *matHeaderCellDef id="last-name-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LAST_NAME"
            [control]="lastNameData.formControl"
            [maxLength]="30"
            [allowedSpecialChar]="CHARS.ALPHABET_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          headers="last-name-headers"
          mat-cell
          *matCellDef="let admin"
          class="left-data-column"
        >
          {{ admin.familyName }}
        </td>
      </ng-container>

      <!-- First name -->
      <ng-container matColumnDef="givenName">
        <th mat-header-cell *matHeaderCellDef id="first-name-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.FIRST_NAME"
            [control]="firstNameData.formControl"
            [maxLength]="30"
            [allowedSpecialChar]="CHARS.ALPHABET_ONLY"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="first-name-headers"
          class="left-data-column"
        >
          {{ admin.givenName }}
        </td>
      </ng-container>

      <!-- Location Group -->
      <ng-container matColumnDef="locationGroupCode">
        <th mat-header-cell *matHeaderCellDef id="location-group-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION_GROUP"
            [control]="locationGroupData.formControl"
            [maxLength]="19"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="location-group-headers"
          class="left-data-column"
        >
          {{ admin.locationGroupCode }}
        </td>
      </ng-container>

      <!-- Location -->
      <ng-container matColumnDef="locationCode">
        <th mat-header-cell *matHeaderCellDef id="location-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LOCATION"
            [control]="locationData.formControl"
            [maxLength]="19"
            [allowedSpecialChar]="CHARS.ADDRESS"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="location-headers"
          class="left-data-column"
        >
          {{ admin.locationCode }}
        </td>
      </ng-container>

      <!-- User Role -->
      <ng-container matColumnDef="roleName">
        <th mat-header-cell *matHeaderCellDef id="user-role-headers">
          <app-table-header-dropdown
            [columnText]="COLUMNTEXT.USER_ROLE"
            [itemId]="userRoleData.itemId"
            [searchResults]="roles"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[0]"
            (focusEvent)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, -2)
            "
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 0)
            "
            (checkboxesUpdated)="
              onStatusChangeForDropdown($event, userRoleData)
            "
            [popoverStyle]="{ maxWidth: 225, offsetX: -65 }"
          >
          </app-table-header-dropdown>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="user-role-headers"
          class="left-data-column"
        >
          {{ admin.roleName }}
        </td>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef id="email-headers">
          <ion-row class="th-text"> {{ COLUMNTEXT.EMAIL }} </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="email-headers"
          class="left-data-column"
        >
          {{ admin.email }}
        </td>
      </ng-container>

      <!-- Last Logged In-->
      <ng-container matColumnDef="lastLoggedIn">
        <th mat-header-cell *matHeaderCellDef id="last-login-headers">
          <app-table-search-component
            [columnName]="COLUMNTEXT.LAST_LOGIN"
            [control]="lastLoginData.formControl"
            [maxLength]="19"
            (emitSearch)="search()"
          ></app-table-search-component>
        </th>
        <td
          mat-cell
          *matCellDef="let admin"
          headers="last-login-headers"
          class="left-data-column"
        >
          {{ admin.lastLoggedIn ?? "" }}
        </td>
      </ng-container>

      <!-- Status -->
      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef id="status-headers">
          <app-table-dropdown-status
            [header]="CONSTS.ACTIVE"
            [data]="statusData"
            [resetData]="resetSelectDropdowns"
            [showDropdown]="dropdownOpen[1]"
            (dropdownChange)="
              dropdownOpen = commonUtils.updateDropdown(dropdownOpen, 1)
            "
            (emitStatusChange)="onStatusChangeForDropdown($event, statusData)"
          >
          </app-table-dropdown-status>
        </th>

        <td
          mat-cell
          *matCellDef="let admin"
          headers="status-headers"
          class="extra-left-data-column"
        >
          <img
            [src]="admin.enabled ? IMAGE.ACTIVE : IMAGE.CANCEL"
            alt="admin-status"
          />
        </td>
      </ng-container>

      <!-- Actions -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef id="action-headers">
          <ion-row class="th-text">
            <span>{{ CONSTS.ACTIONS }}</span>
          </ion-row>
          <ion-row class="search-wrapper">
            <div class="search-header-labels"></div>
          </ion-row>
        </th>
        <td mat-cell *matCellDef="let admin" headers="action-headers">
          @if (canEditUsers || canDeleteUsers) {
            <app-table-action-cell
              [data]="admin"
              [editButtonDisabled]="!canEditUsers"
              [deleteButtonDisabled]="!canDeleteUsers || admin.enabled === true"
              (emitEditButton)="editUser(admin)"
              (emitDeleteButton)="removeUser(admin)"
            ></app-table-action-cell>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [class.selectedRow]="selectedUser === row"
      ></tr>

      <tr class="mat-row no-data-row" *matNoDataRow>
        <td class="mat-cell no-border" [attr.colspan]="displayedColumns.length">
          <app-no-results-found></app-no-results-found>
        </td>
      </tr>
    </table>
  </div>
  <app-table-pagination [datasource]="dataSource"></app-table-pagination>
</body>
